import { render, staticRenderFns } from "./CAdPlaceholder.vue?vue&type=template&id=0971f364&scoped=true&"
import script from "./CAdPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./CAdPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./CAdPlaceholder.vue?vue&type=style&index=0&id=0971f364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971f364",
  null
  
)

export default component.exports